import { PayloadAction, createReducer } from '@reduxjs/toolkit';
import { initialState } from '@modules/orders-and-trips/store';
import { createOrderRoutine, createTripRoutine } from '@modules/orders-and-trips/actions';
import { onFailure } from '@common/utils/helpers/reducers';
import { InitialState } from '../types/general';

export const createTripReducer = createReducer(initialState, {
  [createTripRoutine.REQUEST]: (state: InitialState) => {
    state.trips.isFetching = true;
    return state;
  },
  [createTripRoutine.SUCCESS]: (state: InitialState, action: PayloadAction<{}>) => {
    return state;
  },
  [createOrderRoutine.FAILURE]: onFailure,
  [createOrderRoutine.FULFILL]: (state: InitialState) => {
    state.error = [];
    state.trips.isFetching = false;
    return state;
  }
});
